import React, { useState, useEffect } from "react";
import classNames from "classnames";
import { connect } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import * as Path from "routes/paths";
import { useModules } from "helpers/modules";
const Sidebar = ({ isOpen, user, userProfile }) => {
  let userRole = user?.user ? user?.user : userProfile;

  const [addModuleCss, setAddModuleCss] = useState(false);
  const [modules, setModules] = useState(useModules);
  const [dbmodules, setDbModules] = useState([]);
  //history
  const history = useHistory();
  const pathname = history.location.pathname.split("/");

  const filtered = pathname.filter(function (el) {
    if (el !== "") {
      return el;
    }
  });

  let path = "/";

  if (filtered.length >= 3) {
    path += filtered[0] + "/" + filtered[1] + "/" + filtered[2];
  } else {
    path += filtered[0] + "/" + filtered[1] ?? "";
  }

  useEffect(() => {
    let userPermission =
      userProfile?.user_permissions?.length > 0
        ? userProfile?.user_permissions
        : [];
    let userData =
      user?.user?.user_permissions?.length > 0
        ? user?.user?.user_permissions
        : userPermission;
    let newArr = [];
    for (let val of userData) {
      let moduleName = val.module_name ? JSON.parse(val.module_name) : "";
      newArr.push(moduleName?.value);
    }
    setDbModules(newArr);
  }, [userRole]);

  const onClickToggleCloseOpenTab = () => {
    setAddModuleCss(!addModuleCss);
  };
  return (
    <>
      <nav
        className={`sidebar sidebar-offcanvas ${isOpen ? "active" : ""}`}
        id="sidebar"
      >
        <ul className="nav">
          {modules?.length > 0 &&
            modules.map((mod, i) => {
              dbmodules.filter((val) => {
                if (val === mod.model_name) {
                  mod.is_permission = false;
                }
              });
              let submodules = mod?.is_modules ? mod.sub_modules : "";
              if (!mod.is_permission && userRole?.role === "3") {
                //subadmin
                return (
                  <li
                    className={classNames("nav-item px-3 py-2", {
                      active:
                        path === mod.url ||
                        path === submodules?.add ||
                        path === submodules?.edit ||
                        path === submodules?.edit_form ||
                        path === submodules?.view ||
                        path === submodules?.view_form,
                    })}
                  >
                    <Link
                      className="nav-link px-3 py-2 rounded fw-sbold"
                      to={mod.url}
                    >
                      <i className={`${mod.icon} mx-0`}></i>
                      <span className="menu-title ms-2" title={mod.name}>
                        {mod.name}
                      </span>
                    </Link>
                  </li>
                );
              } else if (mod.is_permission && userRole?.role === "0") {
                //admin
                return (
                  <>
                    {!mod.is_dropdown && (
                      <li
                        className={classNames("nav-item px-3 py-2", {
                          active:
                            path === mod.url ||
                            path === submodules?.add ||
                            path === submodules?.edit ||
                            path === submodules?.edit_form ||
                            path === submodules?.view ||
                            path === submodules?.view_form ||
                            path === submodules?.add_sub ||
                            path === submodules?.edit_sub ||
                            path === submodules?.edit_form_sub ||
                            path === submodules?.view_sub ||
                            path === submodules?.view_form_sub ||
                            path === submodules?.list_sub,
                        })}
                      >
                        <Link
                          className="nav-link px-3 py-2 rounded fw-sbold"
                          to={mod.url}
                        >
                          <span className="menu-title ms-2" title={mod.name}>
                            {mod.name}
                          </span>
                          <i className={`${mod.icon}`}></i>
                        </Link>
                      </li>
                    )}
                    {mod.is_dropdown && (
                      <li
                        className={classNames("nav-item px-3 py-2", {
                          active:
                            path === mod.url ||
                            path === submodules?.add ||
                            path === submodules?.edit ||
                            path === submodules?.edit_form ||
                            path === submodules?.view ||
                            path === submodules?.view_form ||
                            path === mod.sub_modules_urls.url_1 ||
                            path === mod.sub_modules_urls.url_2,
                        })}
                        onClick={onClickToggleCloseOpenTab}
                      >
                        <Link
                          to="#"
                          className={`nav-link px-3 py-2 rounded fw-sbold ${
                            !addModuleCss ? "collapsed" : ""
                          }`}
                          title={mod.name}
                        >
                          <span className="menu-title ms-2">{mod.name}</span>
                          <i className={mod.icon}></i>
                          <i className={`${mod.icon1}`}></i>
                        </Link>
                        <div
                          className={`collapse ${addModuleCss ? "show" : ""}`}
                          id="ui-basic"
                        >
                          <ul className="nav flex-column sub-menu">
                            <li className="nav-item">
                              {" "}
                              <Link
                                className={classNames(
                                  "nav-link  sub-menu-list",
                                  {
                                    active:
                                      path === mod.name ||
                                      path === mod.sub_modules_urls.url_1,
                                  }
                                )}
                                to={mod?.sub_modules_urls?.url_1}
                              >
                                {mod?.sub_name_1}
                              </Link>
                            </li>
                            <li className="nav-item">
                              {" "}
                              <Link
                                className={classNames(
                                  "nav-link sub-menu-list",
                                  {
                                    active:
                                      path === mod.name ||
                                      path === mod.sub_modules_urls.url_2,
                                  }
                                )}
                                to={mod?.sub_modules_urls?.url_2}
                              >
                                {mod?.sub_name_2}
                              </Link>
                            </li>
                            {/* <li className="nav-item"> <Link className="nav-link"  to={mod?.sub_modules_urls?.url_2}>Sales</Link></li> */}
                          </ul>
                        </div>
                      </li>
                    )}
                  </>
                );
              }
            })}
        </ul>
      </nav>
    </>
  );
};
const mapStateToPros = (state) => {
  return {
    isAuthenticated: state.Auth.isAuthenticated,
    loader: state.persistStore.loader,
    user: state.Auth,
    userProfile: state?.persistStore?.userProfile,
  };
};

export default connect(mapStateToPros)(Sidebar);
